<template>
  <div class="footer">

  </div><!--footer 结束-->
</template>


<script>
  export default{
    data:function () {
      return{

      }
    },
    mounted(){

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AccountAdminFooter.vue?6d9c0e76